import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class CargoItemDbTableDefinition extends DbTableDefinition {
    tableName = 'cargoitems';
    tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT NOT NULL,
       databag LONGTEXT,
       extId VARCHAR(255),
       name VARCHAR(255),
       sortKey VARCHAR(255),
       serialNumber VARCHAR(255),
       amtdlv INT(11),
       amtopen INT(11),
       amtreturn INT(11),
       itemvalue DOUBLE,
       servicejobid BIGINT(20),
       servicejoblabel TEXT,
       branchid BIGINT(20),
       branchlabel TEXT,
       tourid BIGINT(20),
       tourlabel TEXT,
       cargoitemtypeid BIGINT(20),
       cargoitemtypelabel TEXT
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
      }
}